var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'minWidth':_vm.$store.state.isPc},attrs:{"id":"app"}},[_c('head-box'),_c('router-view'),_c('my-footer',{staticClass:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }